import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const projectSlice = createSlice({
  name: "projectPage",
  initialState,
  reducers: {
    startRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    requestSuccess: (state, action) => {
      state.loading = false;
      state.error = null;
      state.data = action.payload.data;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload.message || "An error occurred!";
    },
  },
});

export const { startRequest, requestSuccess, requestFailure } =
  projectSlice.actions;
export default projectSlice.reducer;
